import { useTranslation } from "react-i18next";
import SEO from "components/SEO";
import BackedBy from "pages/home/BackedBy";
import CareersHeader from "./CareersHeader";
import CareersList from "./CareersList";
import OurMission from "./OurMission";
import OurValues from "./OurValues";
import RecruitmentProcess from "./RecruitmentProcess";
import WhatWeOffer from "./WhatWeOffer";

function CareersPage() {
    const { t } = useTranslation("careers");
    return (
        <>
            <SEO title={t("meta.title")} description={t("meta.description")} />
            <CareersHeader />
            <BackedBy />
            <OurMission />
            <OurValues />
            <WhatWeOffer />
            <CareersList />
            <RecruitmentProcess />
        </>
    );
}

export default CareersPage;
